import axios from "axios";
import { SET_TOKEN } from "contexts/auth-reducer/actions";

const USER_URL =
  "https://snow-chicken-741763.hostingersite.com/public/api/admin/";

export const token = sessionStorage.getItem("token");

const LANG = sessionStorage.getItem("lang");

const CONFIG = {
  Authorization: `Bearer ${SET_TOKEN}`,
  // Accept: "application/json",
  // "Content-Type": "application/json",
  // "Access-Control-Allow-Origin": "*",
  Language: LANG,
};

export const USERAXIOS = axios.create({
  baseURL: USER_URL,
  headers: CONFIG,
});
